import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

/**
 * LocalBusiness + BreadcrumbList JSON-LD structured data.
 * Injected once at the app level to cover all pages.
 */
export function LocalBusinessSchema() {
  const { lang, t } = useLanguage();
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Ironwood",
    "description": t('seo-home-desc'),
    "url": "https://ironwood.ge/",
    "telephone": "+995511168147",
    "image": "https://ironwood.ge/seo_share.webp",
    "logo": "https://ironwood.ge/assets/logo.webp",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GE",
      "addressLocality": lang === 'ge' ? "საქართველო" : "Georgia"
    },
    "sameAs": [
      "https://www.facebook.com/ironwood.ge",
      "https://wa.me/995511168147"
    ],
    "makesOffer": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": t('gallery-title-gazebos') } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": t('gallery-title-tables') } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": t('gallery-title-chairs') } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": t('gallery-title-fences') } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": t('gallery-title-lights') } }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

/**
 * BreadcrumbList schema — renders per-page breadcrumbs for search engines.
 */
export function BreadcrumbSchema() {
  const location = useLocation();
  const { t } = useLanguage();
  
  const breadcrumbs = [
    { name: t('nav-home'), url: "https://ironwood.ge/" }
  ];

  if (location.pathname === '/gallery') {
    breadcrumbs.push({ name: t('nav-gallery'), url: "https://ironwood.ge/gallery" });
  } else if (location.pathname === '/contact') {
    breadcrumbs.push({ name: t('nav-contact'), url: "https://ironwood.ge/contact" });
  }

  // Only render breadcrumb schema on inner pages
  if (breadcrumbs.length < 2) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
